import { cn } from "@/lib/cn";

type ProductNameProps = {
    name: string;
    meta?: string;
    className?: string;
    withTestIds?: boolean;
};

export function ProductName({
    name,
    meta,
    className,
    withTestIds,
}: ProductNameProps) {
    return (
        <div className={cn("min-w-0", className)}>
            <p
                data-testid={withTestIds ? "confirm-product-type" : undefined}
                className="text-md font-semibold text-gray-800"
            >
                {name}
            </p>
            {meta && (
                <p
                    data-testid={
                        withTestIds ? "confirm-product-meta" : undefined
                    }
                    className="text-xs text-gray-600"
                >
                    {meta}
                </p>
            )}
        </div>
    );
}
